import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes safely — resolves conflicts intelligently */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export { clsx };

export { Button, type ButtonProps } from './components/Button';
export { Input, type InputProps } from './components/Input';
export { Select, type SelectProps } from './components/Select';
export { Textarea, type TextareaProps } from './components/Textarea';
export { Label, FormField, type LabelProps, type FormFieldProps } from './components/FormField';
export { Checkbox, type CheckboxProps } from './components/Checkbox';
export { Badge, type BadgeProps } from './components/Badge';
export { ColorBadge, withAlpha, type ColorBadgeProps } from './components/ColorBadge';
export { Card, CardHeader, CardContent, CardFooter, type CardProps } from './components/Card';
export { Modal, type ModalProps } from './components/Modal';
export { Drawer, type DrawerProps } from './components/Drawer';
export { ConfirmDialog, type ConfirmDialogProps } from './components/ConfirmDialog';
export { Alert, type AlertProps } from './components/Alert';
export { Tabs, type TabsProps } from './components/Tabs';
export { SearchInput, type SearchInputProps } from './components/SearchInput';
export { FilterBar, type FilterBarProps } from './components/FilterBar';
export { Skeleton, type SkeletonProps } from './components/Skeleton';
export { Spinner, type SpinnerProps } from './components/Spinner';
export { PageHeader, type PageHeaderProps } from './components/PageHeader';
export { EmptyState, type EmptyStateProps } from './components/EmptyState';
export { ThemeToggle } from './components/ThemeToggle';
export { DataTable, DATA_TABLE_MAX_HEIGHT, type DataTableColumn, type DataTableProps } from './components/DataTable';
export { Pagination, type PaginationProps } from './components/Pagination';
export { Avatar, type AvatarProps } from './components/Avatar';
